import '../../util/string';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { Grid, IconButton } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

import Brightness5Icon from '@material-ui/icons/Brightness5';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import style from './NewPatientsTabs.module.css';
import { withLang } from '../../util/lang';
import ErrorDialog from './ErrorDialog/ErrorDialog';
import { dialogData, setDialog, setDialogFunction, setDialogMessage } from '../../store/ErrorMessage/ErrorMessageSlice';
import WorkFlowTab from '../Tabs/WorkFlowTab';
import { Base_Prescription_Err, Base_Retainer_Request_Err, CASE_TYPE } from '../../store/NewPatient/utils';
import { smileDesignProductListArray } from '../../store/SmileDesign/SmileDesignSlice';
import { getPrescriptionNotesTabLang, validateImpressionFiles } from './NewPatientUtill';
import {
    alignerPrescriptionFormValidation,
    handleValidationOnTabsChange,
} from '../../util/alignerPrescriptionFormHelper';
import WorkFlowTabSkeleton from '../Tabs/WorkFlowTabSkeleton';

// material ui and css stuff
// import { Grid } from '@material-ui/core'

const styles = (theme) => ({
    root: {
        margin: '48px auto',
        [theme.breakpoints.down('sm')]: {
            margin: '0 auto',
        },
        [theme.breakpoints.up('lg')]: {
            width: '70%',
            minHeight: '400px',
        },
    },
    tabText: {
        marginBlockStart: '8px',
        marginBlockEnd: '8px',
        fontSize: '14px',
        color: '#797979',
        cursor: 'pointer',
    },
    tabTextActive: {
        marginBlockStart: '8px',
        marginBlockEnd: '8px',
        fontSize: '14px',
        color: '#2eafb6',
        cursor: 'pointer',
    },
});

class NewPatientsTabs extends Component {
    constructor(props) {
        super(props);
        this.handleChangeTabLocal = this.handleChangeTabLocal.bind(this);
    }

    componentDidMount() {}

    // Handles step-icon navigation and validates the current step before leaving it.
    handleChangeTabLocal(value) {
        if (this.props.tabMode === 'info') {
            if (this.props.firstName.length == 0) {
                this.props.setDialogMessage(dialogData.firstName.content);
            } else if (this.props.lastName.length == 0) {
                this.props.setDialogMessage(dialogData.lastName.content);
            } else {
                this.props.ErrorData({ id: 'patient_info', msg: '', valid: true });
                this.changetab(value);
            }
        } else if (this.props.tabMode == 'delivery') {
            if (
                this.props.NewPatientAddressData.delivery_id == 'New Address' &&
                this.props.NewPatientAddressData.city.length == 0
            ) {
                this.props.setDialogMessage(dialogData.city.content);
            } else if (
                this.props.NewPatientAddressData.delivery_id == 'New Address' &&
                this.props.NewPatientAddressData.zipCode.length == 0
            ) {
                this.props.setDialogMessage(dialogData.zipCode.content);
            } else if (
                this.props.NewPatientAddressData.delivery_id == 'New Address' &&
                this.props.NewPatientAddressData.phoneNumber.length == 0
            ) {
                this.props.setDialogMessage(dialogData.phone.content);
            } else {
                this.changetab(value);
            }
        } else if (this.props.tabMode === 'photos') {
            let counter = 0;
            if (this.props.NewCaseType !== 'RETAINER' && this.props.NewCaseType !== CASE_TYPE.SELF_DESIGN) {
                this.props.NewPaitientData.files.forEach((v) => {
                    if (
                        [
                            'jaw_side_with_smile',
                            'face_front_with_smile',
                            'teeth_side_without_smile',
                            'jaw_front_with_smile',
                            'teeth_side_with_smile',
                            'jaw_side_without_smile',
                            ...(this.props.displayFirstFitFlag ? ['big_smile_full_face_with_full_retractors'] : []),
                        ].includes(v.id) &&
                        !v.data &&
                        !v.upload_later &&
                        !v.will_not_upload
                    ) {
                        counter += 1;
                    }
                });
            }
            if (counter && this.props.NewCaseType !== 'RETAINER' && this.props.NewCaseType !== CASE_TYPE.SELF_DESIGN) {
                this.props.ErrorData({ id: 'photo', msg: this.get('warning.mandatoryPhoto'), valid: false });
            } else {
                this.props.ErrorData({ id: 'photo', msg: '', valid: true });
            }
            this.changetab(value);
        } else if (this.props.tabMode === 'radiography') {
            let counter = 0;
            if (this.props.NewCaseType !== 'RETAINER' && this.props.NewCaseType !== CASE_TYPE.SELF_DESIGN) {
                this.props.NewPaitientData.files.forEach((v, index) => {
                    if (
                        v.category === 'radio' &&
                        v.id === 'front_with_smile' &&
                        !v.data &&
                        !v.upload_later &&
                        !v.will_not_upload
                    ) {
                        counter += 1;
                    }
                });
            }
            if (counter && this.props.NewCaseType !== 'RETAINER' && this.props.NewCaseType !== CASE_TYPE.SELF_DESIGN) {
                this.props.ErrorData({ id: 'radiograph', msg: this.get('warning.mandatoryRadiograph'), valid: false });
            } else {
                this.props.ErrorData({ id: 'radiograph', msg: '', valid: true });
            }
            this.changetab(value);
        } else if (this.props.tabMode === 'impression') {
            switch (this.props.NewPaitientData.impressionType) {
                case 'FILE': {
                    const impressionFiles = this.props.NewPaitientData.files.filter((v) => v.category === 'stl_file');
                    const impressionErrList = validateImpressionFiles(impressionFiles);
                    if (impressionErrList.length > 0) {
                        this.props.ErrorData({ id: 'impression', msg: this.get('warning.allStl'), valid: false });
                    } else {
                        this.props.ErrorData({ id: 'impression', msg: '', valid: true });
                    }
                    break;
                }
                case 'COURIER': {
                    if (String.isBlank(this.props.NewPaitientData.modernCode)) {
                        this.props.ErrorData({ id: 'impression', msg: this.get('warning.courier'), valid: false });
                    } else {
                        this.props.ErrorData({ id: 'impression', msg: '', valid: true });
                    }
                    break;
                }
                case 'SCANNER': {
                    if (
                        String.isBlank(this.props.NewPaitientData.scannerBrand) ||
                        String.isBlank(this.props.NewPaitientData.doctorId)
                    ) {
                        this.props.ErrorData({ id: 'impression', msg: this.get('warning.scanner'), valid: false });
                    } else {
                        this.props.ErrorData({ id: 'impression', msg: '', valid: true });
                    }
                    break;
                }
            }
            this.changetab(value);
        } else if (this.props.tabMode === 'Trioclear_Order_Form') {
            if (this.props.orderList.length === 0) {
                this.props.setDialogMessage(dialogData.accessoriesQuantity.content);
                return;
            }
            this.changetab(value);
        } else if (
            this.props.tabMode === 'prescriptionNotes' &&
            !smileDesignProductListArray.includes(this.props.NewCaseType)
        ) {
            // Update prescription error state without blocking step navigation.
            const {
                attachments1,
                spacingAndCrowding1,
                openbite1,
                deepBite1,
                midline1,
                posteriorCrossbite1,
                auxiliaries1,
                restorativeOptions,
                preImplantAligment,
                archToTreat,
                anteriorPosteriorRelationship1,
            } = this.props.NewPaitientData;
            const {
                condition1,
                condition3,
                condition4,
                condition5,
                condition6,
                condition7,
                condition8,
                condition9,
                condition10,
                condition11,
                condition12,
                condition13,
                condition14,
                condition16,
                condition17,
                condition18,
                condition19,
                condition20,
                condition21,
                condition22,
                restorativeOptionsSubValueOnlayErr,
                restorativeOptionsVerticalDimensionLowerPosteriorErr,
                restorativeOptionsVerticalDimensionUpperPosteriorErr,
                preImplantAligmentProstheticSpaceErr,
            } = alignerPrescriptionFormValidation({
                attachments: attachments1,
                spacingAndCrowding: spacingAndCrowding1,
                openbite: openbite1,
                deepBite: deepBite1,
                midline: midline1,
                posteriorCrossbite: posteriorCrossbite1,
                auxiliaries: auxiliaries1,
                restorativeOptions,
                preImplantAligment,
                archToTreat,
                anteriorPosteriorRelationship: anteriorPosteriorRelationship1,
            });
            const errorResponse = handleValidationOnTabsChange({
                condition1,
                condition3,
                condition4,
                condition5,
                condition6,
                condition7,
                condition8,
                condition9,
                condition10,
                condition11,
                condition12,
                condition13,
                condition14,
                condition16,
                condition17,
                condition18,
                condition19,
                condition20,
                condition21,
                condition22,
                restorativeOptionsSubValueOnlayErr,
                preImplantAligmentProstheticSpaceErr,
                restorativeOptionsVerticalDimensionPosteriorErr:
                    restorativeOptionsVerticalDimensionUpperPosteriorErr &&
                    restorativeOptionsVerticalDimensionLowerPosteriorErr,
            });
            this.props.ErrorData({
                id: Base_Prescription_Err.id,
                msg: errorResponse.needHandle
                    ? this.get('warning.prescription_notes') || Base_Prescription_Err.msg
                    : Base_Prescription_Err.msg,
                valid: !errorResponse.needHandle,
            });
            this.changetab(value);
        } else if (
            this.props.tabMode === 'prescriptionNotes' &&
            this.props.tabs.includes('prescriptionNotesSD')
        ) {
            // Apply Q14 defaults to ISD form only when navigating forward
            const currentIndex = this.props.tabs.indexOf(this.props.tabMode);
            const targetIndex = this.props.tabs.indexOf(value);
            const isGoingForward = targetIndex > currentIndex;
            if (
                isGoingForward &&
                typeof this.props.smileDesign.applyQ14DefaultsToISDForm === 'function'
            ) {
                this.props.smileDesign.applyQ14DefaultsToISDForm();
            }
            this.changetab(value);
        } else if (this.props.tabMode === 'prescriptionNotesSD') {
            // Validate Q4/Q14 match before navigating to any non-prescription workflow step.
            const shouldValidateQ4Q14 = !['info', 'prescriptionNotes'].includes(value);
            if (shouldValidateQ4Q14 && typeof this.props.smileDesign.validateISDQ4Q14Match === 'function') {
                const isMatch = this.props.smileDesign.validateISDQ4Q14Match();
                if (!isMatch) {
                    this.props.setDialog({
                        title: '@global.const.actionRequired',
                        content: '@NewPatient.warning.verticalDimensionMismatch',
                    });
                    return;
                }
            }
            this.changetab(value);
        } else {
            this.changetab(value);
        }
        this.props.setDialogFunction(() => this.props.handlePrescriptionErrorScroll());
        this.props.smileDesign.handleValidateSmileDesignPrescriptionNotes();
    }

    changetab(value) {
        this.props.handleChangeTab(value);
        this.props.handleValidation({});
    }

    getTabs() {
        return this.props.tabs;
    }

    render() {
        const { classes, NewCaseType, isTabsReady } = this.props;
        let errors = this.props.NewPaitientData.errors;
        const isAlignerCase = NewCaseType !== CASE_TYPE.RETAINER;

        let patient_info_errors = errors.filter((v) => {
            return v.id === 'patient_info';
        });

        let photos_errors = errors.filter((v) => {
            return v.id === 'photo';
        });

        let radiography_errors = errors.filter((v) => {
            return v.id === 'radiograph';
        });

        let impression_errors = errors.filter((v) => {
            return v.id === 'impression';
        });

        let retainer_reqeust_errors = errors.find((e) => e.id === 'retainer_request_prescription');
        // in case of retainer_reqeust_errors is undefined, assign default value for it
        if (!retainer_reqeust_errors) {
            retainer_reqeust_errors = Base_Retainer_Request_Err;
        }
        // this error only for case type === RETAINER
        // skip checking for other case type
        if (NewCaseType !== 'RETAINER') {
            retainer_reqeust_errors.valid = true;
        }

        return (
            // <Grid container className={style.gridContainer}>
            <Grid
                container
                style={{
                    padding: 16,
                    overflowX: 'scroll',
                    marginBottom: 48,
                }}
                className={style.customScrollBar}
            >
                <ErrorDialog />

                {/* controlling tab button */}
                {/* 
        complete = ["info", "questionnaire", "questionnaire_smile_design"(optional), "photos", "radiography", "impression", "delivery", "summary"]
        retainer = ["info", "retainer_request_prescriptionNotes", "impression", "delivery", "summary"]*/}

                <div style={{ display: 'flex', margin: 'auto' }}>
                    {isAlignerCase && isTabsReady && (
                        <>
                            {this.getTabs().map((tab) => {
                                if (tab.name === 'prescriptionNotes') {
                                    tab.lang = getPrescriptionNotesTabLang(NewCaseType);
                                }
                                return (
                                    <WorkFlowTab
                                        key={tab.tab}
                                        handleChangeTabLocal={this.handleChangeTabLocal}
                                        props={this.props}
                                        name={tab.name}
                                        tab={tab.tab}
                                        lang={tab.lang}
                                        Icon={tab.icon}
                                        showArrow={tab.name !== 'summary'}
                                    />
                                );
                            })}
                        </>
                    )}
                    {isAlignerCase &&
                        !isTabsReady &&
                        Array.from({ length: 7 }).map((_, index) => {
                            return <WorkFlowTabSkeleton key={`skeleton-${index}`} showArrow={index !== 6} />;
                        })}

                    {NewCaseType === 'RETAINER' && (
                        <>
                            <Grid item style={{ textAlign: 'center', display: 'flex' }}>
                                <div
                                    className={style.iconButtonContainer}
                                    onClick={() => this.handleChangeTabLocal('info')}
                                >
                                    <div className={style.CustomBadgeContainer}>
                                        {patient_info_errors[0] && !patient_info_errors[0].valid ? (
                                            <span className={style.CustomBadge}>*</span>
                                        ) : (
                                            <span className={style.CustomBadge} style={{ display: 'none' }}>
                                                *
                                            </span>
                                        )}
                                        <IconButton
                                            aria-label="delete"
                                            style={{
                                                background: this.props.tabMode === 'info' ? '#2eafb6' : '#bababa',
                                            }}
                                            className={style.iconButton}
                                        >
                                            <InfoIcon />
                                        </IconButton>
                                    </div>
                                    <p
                                        className={
                                            this.props.tabMode === 'info' ? classes.tabTextActive : classes.tabText
                                        }
                                    >
                                        {this.get('tabs.info')}
                                    </p>
                                </div>

                                <div className={style.iconButtonArrowContainer}>
                                    <IconButton aria-label="delete" disabled className="iconButtonArrow">
                                        <KeyboardArrowRightIcon />
                                    </IconButton>
                                </div>
                            </Grid>

                            <Grid item style={{ textAlign: 'center', display: 'flex' }}>
                                <div
                                    className={style.CustomBadgeContainer}
                                    onClick={() => this.handleChangeTabLocal('retainer_request_prescriptionNotes')}
                                >
                                    {!retainer_reqeust_errors.valid ? (
                                        <span className={style.CustomBadge}>*</span>
                                    ) : (
                                        <span className={style.CustomBadge} style={{ display: 'none' }}>
                                            *
                                        </span>
                                    )}
                                    <IconButton
                                        aria-label="delete"
                                        style={{
                                            background:
                                                this.props.tabMode === 'retainer_request_prescriptionNotes'
                                                    ? '#2eafb6'
                                                    : '#bababa',
                                        }}
                                        className={style.iconButton}
                                    >
                                        <QuestionAnswerIcon />
                                    </IconButton>
                                    <p
                                        className={
                                            this.props.tabMode === 'retainer_request_prescriptionNotes'
                                                ? classes.tabTextActive
                                                : classes.tabText
                                        }
                                    >
                                        {this.get('tabs.prescriptionNotes')}
                                    </p>
                                </div>

                                <div className={style.iconButtonArrowContainer}>
                                    <IconButton aria-label="delete" disabled className="iconButtonArrow">
                                        <KeyboardArrowRightIcon />
                                    </IconButton>
                                </div>
                            </Grid>

                            <Grid item style={{ textAlign: 'center', display: 'flex' }}>
                                <div
                                    className={style.iconButtonContainer}
                                    onClick={() => this.handleChangeTabLocal('impression')}
                                >
                                    <div className={style.CustomBadgeContainer}>
                                        {impression_errors[0] && !impression_errors[0].valid ? (
                                            <span className={style.CustomBadge}>*</span>
                                        ) : (
                                            <span className={style.CustomBadge} style={{ display: 'none' }}>
                                                *
                                            </span>
                                        )}
                                        <IconButton
                                            aria-label="delete"
                                            style={{
                                                background: this.props.tabMode === 'impression' ? '#2eafb6' : '#bababa',
                                            }}
                                            className={style.iconButton}
                                        >
                                            <Brightness5Icon />
                                        </IconButton>
                                    </div>
                                    <p
                                        className={
                                            this.props.tabMode === 'impression'
                                                ? classes.tabTextActive
                                                : classes.tabText
                                        }
                                    >
                                        {this.get(':fields.impression')}
                                    </p>
                                </div>

                                <div className={style.iconButtonArrowContainer}>
                                    <IconButton aria-label="delete" disabled className="iconButtonArrow">
                                        <KeyboardArrowRightIcon />
                                    </IconButton>
                                </div>
                            </Grid>

                            <Grid item style={{ textAlign: 'center', display: 'flex' }}>
                                <div
                                    className={style.iconButtonContainer}
                                    onClick={() => this.handleChangeTabLocal('delivery')}
                                >
                                    <IconButton
                                        aria-label="delete"
                                        style={{
                                            background: this.props.tabMode === 'delivery' ? '#2eafb6' : '#bababa',
                                        }}
                                        className={style.iconButton}
                                    >
                                        <LocalShippingIcon />
                                    </IconButton>
                                    <p
                                        className={
                                            this.props.tabMode === 'delivery' ? classes.tabTextActive : classes.tabText
                                        }
                                    >
                                        {this.get('tabs.delivery')}
                                    </p>
                                </div>

                                <div className={style.iconButtonArrowContainer}>
                                    <IconButton aria-label="delete" disabled className="iconButtonArrow">
                                        <KeyboardArrowRightIcon />
                                    </IconButton>
                                </div>
                            </Grid>

                            <Grid
                                item
                                style={{ textAlign: 'center', display: 'flex' }}
                                className={style.gridContainerLast}
                            >
                                <div
                                    className={style.iconButtonContainer}
                                    onClick={() => this.handleChangeTabLocal('summary')}
                                >
                                    <IconButton
                                        aria-label="delete"
                                        style={{
                                            background: this.props.tabMode === 'summary' ? '#2eafb6' : '#bababa',
                                        }}
                                        className={style.iconButton}
                                    >
                                        <InsertDriveFileIcon />
                                    </IconButton>
                                    <p
                                        className={
                                            this.props.tabMode === 'summary' ? classes.tabTextActive : classes.tabText
                                        }
                                    >
                                        {this.get('tabs.summary')}
                                    </p>
                                </div>
                            </Grid>
                        </>
                    )}
                </div>
            </Grid>
        );
    }
}

/**
 * Maps Redux state to workflow tab props.
 */
const mapStateToProps = (store) => {
    return {
        NewPaitientData: store.newPatientReducer,
        lang: store.lang,
        errorMessage: store.errorMessage,
        smileDesign: store.smileDesign,
        diffRetainer: store.diffRetainer,
        displayFirstFitFlag: store.globalReducer.displayFirstFitFlag,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        ErrorData: (errorMsg) => dispatch({ type: 'NEW_PATIENT_DATA_ERROR', errorMsg: errorMsg }),
        handlePrescriptionError: (error) => dispatch({ type: 'NEW_PATIENT_PRES_ERROR', error }),
        handlePrescriptionErrorScroll: () => dispatch({ type: 'NEW_PATIENT_PRES_ERROR_SCROLL' }),

        setDialogMessage: (errorMsg) => dispatch(setDialogMessage(errorMsg)),
        setDialog: (payload) => dispatch(setDialog(payload)),
        setDialogFunction: (func) => dispatch(setDialogFunction(func)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(withRouter(withLang(NewPatientsTabs, 'NewPatient'))));
